import CardVideoPlayer from "@/components/VideoSlider/CardVideoPlayer";
import mq from "@/utils/mq";
import useEmblaCarousel from "embla-carousel-react";
import { useEffect } from "react";
import styled, { css } from "styled-components";

const CarouselWrapper = styled.div`
  overflow: hidden;
  position: relative;
  margin-top: 86px;
  ${mq.mobile(css`
    margin-top: 24px;
    margin-bottom: 8px;
  `)};
`;

const CarouselContainer = styled.div`
  display: flex;
  margin-left: calc((100% - (3 * 30%) - (2 * 24px)) / 2);
  margin-right: calc((100% - (3 * 30%) - (2 * 24px)) / 2);
  margin-bottom: 32px;
  ${mq.mobile(css`
    margin-left: 0px;
    margin-right: 8px;
    margin-bottom: 0px;
  `)};
`;

const EmblaSlide = styled.div`
  height: 485px;
  width: auto;
  aspect-ratio: 3/4;
  margin-right: 24px;
  ${mq.mobile(css`
    margin-right: 16px;
    aspect-ratio: 3/4;
    height: 385px;
  `)};
`;

interface MobileVideoSliderProps {
  videoItems: any[];
  activeIndex: number;
  handleProgression: () => void;
  muted: boolean;
  setMuted: (muted: boolean) => void;
  onSlideChange?: (index: number) => void;
}

export default function MobileVideoSlider({
  videoItems,
  activeIndex,
  handleProgression,
  muted,
  setMuted,
  onSlideChange,
}: MobileVideoSliderProps) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
    duration: 25,
  });

  useEffect(() => {
    if (!emblaApi) return;

    const onSelect = () => {
      const selectedIndex = emblaApi.selectedScrollSnap();
      if (onSlideChange) {
        onSlideChange(selectedIndex);
      }
    };

    emblaApi.on("select", onSelect);

    return () => {
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi, onSlideChange]);

  useEffect(() => {
    if (!emblaApi) return;

    emblaApi.scrollTo(activeIndex);
  }, [emblaApi, activeIndex]);

  return (
    <CarouselWrapper ref={emblaRef}>
      <CarouselContainer>
        {videoItems &&
          videoItems.map((video, index) => (
            <EmblaSlide key={video?._uid || index}>
              <CardVideoPlayer
                videoItem={video}
                active={index === activeIndex}
                handleProgression={handleProgression}
                muted={muted}
                setMuted={setMuted}
                mobile={true}
              />
            </EmblaSlide>
          ))}
      </CarouselContainer>
    </CarouselWrapper>
  );
}
